const JsonToArray = function(jsonArr) {
    let arr = [];
    for (var i in jsonArr) {
        arr.push(jsonArr[i])
    }
    return arr;
}

const formateDate = function(fmt, date) {
    let o = {
        'M+': date.getMonth() + 1, // 月份
        'd+': date.getDate(), // 日
        'h+': date.getHours(), // 小时
        'm+': date.getMinutes(), // 分
        's+': date.getSeconds(), // 秒
        'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
        'S': date.getMilliseconds() // 毫秒
    };
    let initfmt;
    if (/(y+)/.test(fmt)) {
        initfmt = fmt.replace(RegExp.$1, (String(date.getFullYear())).substr(4 - RegExp.$1.length));
    }
    for (let k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
            initfmt = initfmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr((String(o[k])).length)));
        }
    }
    return initfmt;
};

const uniqueArray = function(array) {
    var temp = []; //一个新的临时数组
    for (var i = 0; i < array.length; i++) {
        if (temp.indexOf(array[i]) == -1) {
            temp.push(array[i]);
        }
    }
    return temp;
};

export const getCurrentDay = () => {
    var now = new Date();
    var year = now.getFullYear(); //年
    var month = now.getMonth() + 1; //月
    var day = now.getDate(); //日

    var clock = year + "-";
    if (month < 10)
        clock += "0";

    clock += month + "-";
    if (day < 10)
        clock += "0";

    clock += day;
    return clock;
};

export const getDay = (n) => {
    if (!n) n = 0
    var date = new Date();
    date.setTime(date.getTime() + 24 * 60 * 60 * 1000 * n);
    
    var year = date.getFullYear(); //年
    var month = date.getMonth() + 1; //月
    var day = date.getDate(); //日

    var clock = year + "-";
    if (month < 10)
        clock += "0";

    clock += month + "-";
    if (day < 10)
        clock += "0";

    clock += day;
    return clock;
};

const getCurrentMonth = () => {
    var now = new Date();
    var year = now.getFullYear(); //年
    var month = now.getMonth() + 1; //月

    var clock = year + "-";
    if (month < 10)
        clock += "0";

    clock += month
    return clock;
};

export const getCurrentTime = () => {
    var now = new Date();
    var year = now.getFullYear(); //年
    var month = now.getMonth() + 1; //月
    var day = now.getDate(); //日

    var hh = now.getHours(); //时
    var mm = now.getMinutes(); //分
    var ss = now.getSeconds(); //分

    var clock = year + "-";
    if (month < 10)
        clock += "0";

    clock += month + "-";
    if (day < 10)
        clock += "0";

    clock += day + " ";
    if (hh < 10)
        clock += "0";

    clock += hh + ":";
    if (mm < 10)
        clock += '0';
    clock += mm + ":";
    if (ss < 10)
        clock += '0';
    clock += ss;
    return clock;
};

export const getTime = () => {
    var now = new Date();

    var hh = now.getHours(); //时
    var mm = now.getMinutes(); //分
    var ss = now.getSeconds(); //分

    var clock = hh + ":";
    if (mm < 10)
        clock += '0';
    clock += mm + ":";
    if (ss < 10)
        clock += '0';
    clock += ss;
    return clock;
};

const getNowFormatDate = function() {
    var date = new Date();
    var seperator1 = "-";
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var strDate = date.getDate();
    if (month >= 1 && month <= 9) {
        month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
    }
    var currentdate = year + seperator1 + month + seperator1 + strDate;
    return currentdate;
}

const toDecimal = function(x) {
    var f = parseFloat(x);
    if (isNaN(f)) {
        return;
    }
    f = Math.round(x * 100) / 100;
    return f;
}

const isNum = (rule, value, callback) => {
    const age = /^[0-9]*$/
    if (!age.test(value)) {
        callback(new Error('只能为数字'))
    } else {
        callback()
    }
}

const isNumber = (n) => {
    if (!isNaN(n)) {
        return true
    } else {
        false
    }
}

const getFileName = (o) => {
    var pos = o.lastIndexOf("\\");
    return o.substring(pos + 1);
}

const getYear = (n) => {
    var now = new Date();
    var year = now.getFullYear() + n; //年
    var month = now.getMonth() + 1; //月
    var day = now.getDate() + 1; //日

    var clock = year + "-";
    if (month < 10)
        clock += "0";

    clock += month + "-";
    if (day < 10)
        clock += "0";

    clock += day;
    return clock;
};
const getYearAdd = (n) => {
    var now = new Date();
    var year = now.getFullYear() + n; //年
    var month = now.getMonth() + 1; //月
    var day = now.getDate() - 1; //日

    var clock = year + "-";
    if (month < 10)
        clock += "0";

    clock += month + "-";
    if (day < 10)
        clock += "0";

    clock += day;
    return clock;
};
const getYearAddS = (date, n) => {
    var now = new Date(Date.parse(date.replace(/-/g, "/")))
    var year = now.getFullYear() + n; //年
    var month = now.getMonth() + 1; //月
    var day = now.getDate() - 1; //日

    var clock = year + "-";
    if (month < 10)
        clock += "0";

    clock += month + "-";
    if (day < 10)
        clock += "0";

    clock += day;
    return clock;
};

const isEmpty = (param) => {
    if (param) {
        var param_type = typeof(param);
        if (param_type == 'object') {
            //要判断的是【对象】或【数组】或【null】等
            if (typeof(param.length) == 'undefined') {
                if (JSON.stringify(param) == "{}") {
                    return true; //空值，空对象
                }
            } else if (param.length == 0) {
                return true; //空值，空数组
            }
        } else if (param_type == 'string') {
            //如果要过滤空格等字符
            var new_param = param.trim();
            if (new_param.length == 0) {
                //空值，例如:带有空格的字符串" "。
                return true;
            }
        } else if (param_type == 'boolean') {
            if (!param) {
                return true;
            }
        } else if (param_type == 'number') {
            if (!param) {
                return true;
            }
        }
        return false; //非空值
    } else {
        //空值,例如：
        //(1)null
        //(2)可能使用了js的内置的名称，例如：var name=[],这个打印类型是字符串类型。
        //(3)空字符串''、""。
        //(4)数字0、00等，如果可以只输入0，则需要另外判断。
        return true;
    }
}

// 手机号校验
export function isPhoneNumber(phoneNum) {
    // let reg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
    /*
      * 移动号码包括的号段：134/135/136/137,138,139；
    *                     147/148(物联卡号)；
    *                     150/151/152/157/158/159；
    *                     165（虚拟运营商）；
    *                     1703/1705/1706（虚拟运营商）、178；
    *                     182/183/184/187/188
    *                     198

    * 联通号段包括：130/131
    *               145
    *               155/156
    *               166/167(虚拟运营商)
    *               1704/1707/1708/1709、171
    *               186/186
    *
    * 电信号段包括： 133
    *                153
    *                162(虚拟运营商)
    *                1700/1701/1702(虚拟运营商)
    *                180/181/189
    *                191/199
    * */
    let reg = /^1(3[0-9]|4[0-9]|5[0-9]|6[0-9]|7[0-9]|8[0-9]|9[1,8,9])\d{8}$/;
    return reg.test(phoneNum);
}

const aCity = { 11: "北京", 12: "天津", 13: "河北", 14: "山西", 15: "内蒙古", 21: "辽宁", 22: "吉林", 23: "黑龙江", 31: "上海", 32: "江苏", 33: "浙江", 34: "安徽", 35: "福建", 36: "江西", 37: "山东", 41: "河南", 42: "湖北", 43: "湖南", 44: "广东", 45: "广西", 46: "海南", 50: "重庆", 51: "四川", 52: "贵州", 53: "云南", 54: "西藏", 61: "陕西", 62: "甘肃", 63: "青海", 64: "宁夏", 65: "新疆", 71: "台湾", 81: "香港", 82: "澳门", 91: "国外" }
export function isCardID(sId) {
    var iSum = 0;
    if (!/^\d{17}(\d|x)$/i.test(sId)) return false;
    sId = sId.replace(/x$/i, "a");
    if (aCity[parseInt(sId.substr(0, 2))] == null) return false;
    let sBirthday = sId.substr(6, 4) + "-" + Number(sId.substr(10, 2)) + "-" + Number(sId.substr(12, 2));
    var d = new Date(sBirthday.replace(/-/g, "/"));
    if (sBirthday != (d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate())) return false;
    for (var i = 17; i >= 0; i--) iSum += (Math.pow(2, i) % 11) * parseInt(sId.charAt(17 - i), 11);
    if (iSum % 11 != 1) return false;
    return true;
}

export default {
    JsonToArray,
    formateDate,
    uniqueArray,
    getCurrentTime,
    getCurrentDay,
    getDay,
    getCurrentMonth,
    getNowFormatDate,
    toDecimal,
    isNum,
    isNumber,
    getFileName,
    getYear,
    getYearAdd,
    getYearAddS,
    isEmpty,
    isPhoneNumber,
    isCardID,
    getTime
}